import React from 'react';

const SrSafariToolbarSpace = () => {
  return (
    <div className='SrSafariToolbarSpace' />
  );
};

SrSafariToolbarSpace.displayName = 'SrSafariToolbarSpace';

export default SrSafariToolbarSpace;
